module.exports = __webpack_public_path__ + "static/media/team1.d76a18e1.jpg";